import get_project from "./get-project";

export const PREVIEW_API = {
  get_project: get_project,
};
